// src/components/admin/FieldLabel.jsx
const FieldLabel = ({ label, hint }) => (
  <div className="flex items-center gap-2 text-sm font-medium text-gray-700">
    <span>{label}</span>
    {hint && <span className="text-xs text-gray-400">{hint}</span>}
  </div>
);
export default FieldLabel;
